import { FileDropExtension } from '@blocksuite/hive-components/drop-indicator';
import { BrushElementRendererExtension } from '@blocksuite/hive-gfx-brush';
import {
  ConnectorElementRendererExtension,
  ConnectorElementView,
} from '@blocksuite/hive-gfx-connector';
import {
  GroupElementRendererExtension,
  GroupElementView,
} from '@blocksuite/hive-gfx-group';
import {
  MindmapElementRendererExtension,
  MindMapView,
} from '@blocksuite/hive-gfx-mindmap';
import {
  HighlighterElementRendererExtension,
  ShapeElementRendererExtension,
  ShapeElementView,
} from '@blocksuite/hive-gfx-shape';
import {
  TextElementRendererExtension,
  TextElementView,
} from '@blocksuite/hive-gfx-text';
import { NoteBlockSchema } from '@blocksuite/hive-model';
import {
  AutoClearSelectionService,
  DNDAPIExtension,
  DocModeService,
  EmbedOptionService,
  PageViewportServiceExtension,
  ThemeService,
  ToolbarModuleExtension,
  ToolbarRegistryExtension,
} from '@blocksuite/hive-shared/services';
import { dragHandleWidget } from '@blocksuite/hive-widget-drag-handle';
import { linkedDocWidget } from '@blocksuite/hive-widget-linked-doc';
import { docRemoteSelectionWidget } from '@blocksuite/hive-widget-remote-selection';
import { scrollAnchoringWidget } from '@blocksuite/hive-widget-scroll-anchoring';
import { SlashMenuExtension } from '@blocksuite/hive-widget-slash-menu';
import { toolbarWidget } from '@blocksuite/hive-widget-toolbar';
import { BlockFlavourIdentifier, FlavourExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';

import { RootBlockAdapterExtensions } from '../adapters/extension';
import { clipboardConfigs } from '../clipboard';
import { builtinToolbarConfig } from '../configs/toolbar';
import { fallbackKeymap } from '../keyboard/keymap';
import { viewportOverlayWidget } from './widgets';

/**
 * Why do we add these extensions into CommonSpecs?
 * Because in some cases we need to create edgeless elements in page mode.
 * And these view may contain some logic when elements initialize.
 */
const EdgelessElementViews = [
  ConnectorElementView,
  MindMapView,
  GroupElementView,
  TextElementView,
  ShapeElementView,
];

export const EdgelessElementRendererExtension: ExtensionType[] = [
  BrushElementRendererExtension,
  HighlighterElementRendererExtension,
  ShapeElementRendererExtension,
  TextElementRendererExtension,
  ConnectorElementRendererExtension,
  GroupElementRendererExtension,
  MindmapElementRendererExtension,
];

export const CommonSpecs: ExtensionType[] = [
  FlavourExtension('hive:page'),
  DocModeService,
  ThemeService,
  EmbedOptionService,
  PageViewportServiceExtension,
  DNDAPIExtension,
  FileDropExtension,
  ToolbarRegistryExtension,
  AutoClearSelectionService,
  ...RootBlockAdapterExtensions,
  ...clipboardConfigs,
  ...EdgelessElementViews,
  ...EdgelessElementRendererExtension,
  SlashMenuExtension,
  linkedDocWidget,
  dragHandleWidget,
  docRemoteSelectionWidget,
  viewportOverlayWidget,
  scrollAnchoringWidget,
  toolbarWidget,
  fallbackKeymap,

  ToolbarModuleExtension({
    id: BlockFlavourIdentifier(NoteBlockSchema.model.flavour),
    config: builtinToolbarConfig,
  }),
];

export * from './widgets';
